import { Head, router, useForm } from "@inertiajs/react"

import PartnerAccountForm from "@/components/partner-accounts/account-form"
import RecordForm from "@/components/record-form"
import PartnerLayout from "@/layouts/partner-layout"
import { partnerAccountPath } from "@/routes"

interface Account {
  uid: string
  name: string
}

export default function EditAccount({ account }: { account: Account }) {
  const isDemo = account.uid.startsWith("demo-")
  const { data, setData, patch, processing, errors } = useForm({
    account: { name: account.name },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (isDemo) return
    patch(partnerAccountPath({ id: account.uid }))
  }

  function handleCancel() {
    router.visit(partnerAccountPath({ id: account.uid }))
  }

  return (
    <PartnerLayout>
      <Head title={`Edit ${account.name}`} />
      <div className="flex h-full flex-col gap-6">
        <div className="mx-auto w-full max-w-2xl">
          <h1 className="text-2xl/8 font-semibold">Edit {account.name}</h1>
        </div>
        <RecordForm
          submitLabel="Save"
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          processing={processing}
          disabled={isDemo}
          footerBleedClassName="-mx-6 -mb-6 lg:-mx-10 lg:-mb-10"
        >
          <PartnerAccountForm data={data} setData={setData} errors={errors} />
        </RecordForm>
      </div>
    </PartnerLayout>
  )
}
